import React from 'react';

interface AmountProps {
    amount: number;
    currency?: string;
    formatStyle?:string,
    locale?: string;
    className?:string,
    decimalPlaces?: number
}

export const Amount: React.FC<AmountProps> = ({ amount, currency = 'CLP', locale = 'es-US', className = '', formatStyle = 'currency', decimalPlaces = 0 }) => {    
    const safeDecimalPlaces = Math.max(0, decimalPlaces);
    const formatOptions = {
        style: formatStyle as 'decimal' | 'currency' | 'percent',
        currency: currency,
        minimumFractionDigits: safeDecimalPlaces,
        maximumFractionDigits: safeDecimalPlaces,
    };
    
    const formattedAmount = new Intl.NumberFormat(locale, formatOptions).format(amount);
    
    return (
        <span className={className}>{formattedAmount}</span>
    );
};



export default Amount;
